<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon" />
				操作零售单
			</div>
			<button class="jxyd-button jxyd-primary" title="过账" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				过账
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-sync" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>

					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title" style="padding-bottom:5px;">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						商品信息
					</div>
					<div class="layout-title-right">
						<SelectCommodityModal ref="selectCommodityModal"
							@getResult="data=>{this.commoditySelected = data;}" :selectedCommodity="commoditySelected"
							:type='"2"'></SelectCommodityModal>
						<SelectCommodityByCodeModal ref="selectCommodityByCodeModal"
							:commoditySelected="commoditySelected"
							@submitSelected='data=>{this.commoditySelected = data;}' @onInputVal='onInputVal'
							:type='"2"'></SelectCommodityByCodeModal>
					</div>
				</div>
				<Table stripe :columns="commodityColumn" :data="documentItem.retailDetailList"></Table>
			</div>
			<div id="extraCostInfo">
				<ExtraCostData :selectedExtraCost.sync='documentItem.extraCostInfos'></ExtraCostData>
			</div>
			<div class="logisticsInfo">
				<LogisticsInfo :selectedLogistics.sync='documentItem.logisticsInfos'></LogisticsInfo>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div id="voucher-bottomBar">
				<table style="float: left;">
					<tr>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">合计：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.originalPrice}}</span>
						</td>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">折后金额：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.amount}}</span>
						</td>
						<td style="font-size: 16px;font-weight: bold;color: var(--font1Color);padding-left:15px;">支付方式：
						</td>
						<td>
							<SelectTradeMethod :value.sync='documentItem.payWay' :accountPid='accountPid'>
							</SelectTradeMethod>
						</td>
						<td style="padding-left: 5px;">
							<!-- <InputNumber v-model="documentItem.payAmount" :min="0" placeholder="付款金额"
								@on-change="!documentItem.payAmount ? documentItem.payAmount = 0 : documentItem.payAmount = documentItem.payAmount">
							</InputNumber> -->
						</td>
					</tr>
				</table>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已过账</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import SelectCommodityModal from '@/components/SelectCommodityModal'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import SelectTradeMethod from '@/components/SelectTradeMethod'
	import DocumentFile from '@/components/DocumentFile'
	import LogisticsInfo from '@/components/LogisticsInfo'
	import ExtraCostData from '@/components/ExtraCostData'
	import SelectCommodityByCodeModal from '@/components/SelectCommodityByCodeModal'
	export default {
		name: 'retaillistfunc',
		components: {
			SelectCommodityModal,
			DocumentFile,
			LogisticsInfo,
			ExtraCostData,
			SelectCommodityByCodeModal,
			SelectTradeMethod
		},
		computed: {
			commoditySelected: {
				get() {
					let data = [];
					this.documentItem.retailDetailList.forEach(item => {
						let formatItems = item.format.split(',');
						let priceTypeData = {};
						let imgFiles = null;
						if (formatItems.length > 1) {
							let priceTypeGroup = item.commodity.commodityPriceTypeGroups.find(m => m
								.groupName == formatItems[0]);
							if (priceTypeGroup) {
								imgFiles = priceTypeGroup.imgFiles;
							}
							priceTypeData = priceTypeGroup.commodityPriceTypes.find(m => m.priceType ==
								formatItems[1]);
						}
						let existData = data.find(m => m.commodity.id == item.commodity.id);
						let isExist = true;
						if (existData) {
							for (let i = 0; i < existData.data.length; i++) {
								if (existData.data[i].unit != item.unit) {
									isExist = false;
									break;
								}
								if (existData.data[i].priceType == item.format) {
									isExist = false;
									break;
								}
							}
						}
						if (existData && isExist) {
							existData.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								unit: item.unit,
								price: item.price,
								discount:item.discount,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
						} else {

							let dataItem = {};
							dataItem.commodity = item.commodity;

							dataItem.data = [];
							dataItem.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								unit: item.unit,
								price: item.price,
								discount:item.discount,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
							data.push(dataItem);
						}
					});
					return data;
				},
				set(newValue) {
					//这的data就是B页面传递过来的数据
					this.documentItem.retailDetailList = [];
					newValue.forEach(item => {
						item.data.forEach(item2 => {
							let detail = {
								commodityId: item.commodity.id,
								name: item.commodity.name,
								unit: item2.unit,
								format: item2.priceType,
								quantity: item2.quantity,
								batchCode: this.getLatestBatchCode(item, item2),
								depotId: this.documentItem.depotId ? this
									.documentItem
									.depotId : 0,
								depotName: this.documentItem.depotName ? this
									.documentItem.depotName : '',
								price: item2.price,
								discount: item2.discount ? item2.discount : 100,
								priceAfterDiscount: 0,
								amount: 0,
								note: '',
								creator: parseInt(localStorage.getItem("userId")),
								commodity: item.commodity,
								commodityId: item.commodity.id
							};
							detail.price = item2.price? item2.price : this.getCommodityTypePrice(detail);
							detail.priceAfterDiscount =formatNum(detail.price * (detail.discount/100)) ;
							detail.amount = formatNum(detail.quantity * detail
								.priceAfterDiscount)
							this.documentItem.retailDetailList.push(detail);
						});
					});
				}
			}
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					originalPrice:0,
					amount: 0,
					payAmount: 0,
					retailDetailList: [],
					extraCostInfos: [],
					logisticsInfos: [],
					customerId: 0,
					customerName: '',
					customerDiscount: '100',
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					payWay: '',
					checkState: 1, //未过账
					fileList: []
				},
				commodityColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.retailDetailList.splice(params.index, 1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 345,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '单位',
						key: 'unit',
						width: 130,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (event) => {
											this.documentItem.retailDetailList[params.index].unit =
												event;
											this.unitChange(params.index);
										}
									},
								},
								params.row.commodity.extraUnits.map(function(type) {
									return h('Option', {
										props: {
											value: type.unit,
											key: type.unit
										}
									}, type.unit);
								})
							)];
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 140,
					},
					{
						title: '批次号',
						key: 'batchCode',
						width: 200,
						render: (h, params) => {
							return [h('Select', {
									props: {
										disabled:!params.row.commodity.enableBatch,
										multiple:true,
										transfer: true,
										value: params.row.batchCode
									},
									on: {
										input: (event) => {
										}
									},
								},
								this.formatBatchCodeSelectData(params.index,params.row.unit).map(function(type) {
									return h('Option', {
										props: {
											value: type.value,
											key: type.text
										}
									}, type.text);
								})
							)];
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity,
									'max': this.getSelectedCommodityTypeMaxStock(params.index)
								},
								on: {
									input: (e) => {
										this.documentItem.retailDetailList[params.index].quantity =
											e;
										this.$nextTick(function() {
											if (e == null) {
												this.documentItem.retailDetailList[params
													.index].quantity = 0;
											}
											this.$set(this.documentItem.retailDetailList[
													params.index],
												`priceAfterDiscount`, formatNum(this
													.documentItem.retailDetailList[
														params.index].price * (this
														.documentItem.retailDetailList[
															params.index].discount /
														100)));
											this.$set(this.documentItem.retailDetailList[
												params.index], `amount`, formatNum(
												this.documentItem.retailDetailList[
													params.index].quantity * this
												.documentItem.retailDetailList[
													params.index]
												.priceAfterDiscount));

										})
									}
								}
							})]
						}
					},
					{
						title: '单价',
						key: 'price',
						width: 140,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.price
								},
								on: {
									input: (e) => {
										this.documentItem.retailDetailList[params.index].price = e;
										this.$nextTick(function() {
											if (e == null) {
												this.documentItem.retailDetailList[params
													.index].price = 0;
											} else if (e < 0) {
												this.documentItem.retailDetailList[params
													.index].price = 0;
											}
											this.$set(this.documentItem.retailDetailList[
													params.index],
												`priceAfterDiscount`, formatNum(this
													.documentItem.retailDetailList[
														params.index].price * (this
														.documentItem.retailDetailList[
															params.index].discount /
														100)));
											this.$set(this.documentItem.retailDetailList[
												params.index], `amount`, formatNum(
												this.documentItem.retailDetailList[
													params.index].quantity * this
												.documentItem.retailDetailList[
													params.index]
												.priceAfterDiscount));

										})
									}
								}
							})]
						}
					},
					{
						title: '折扣(%)',
						key: 'discount',
						width: 140,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'max': 100,
									'value': params.row.discount
								},
								on: {
									input: (e) => {
										this.documentItem.retailDetailList[params.index].discount =
											e;
										this.$nextTick(function() {
											if (e == null) {
												this.documentItem.retailDetailList[params
													.index].discount = 100;
											} else if (e < 0) {
												this.documentItem.retailDetailList[params
													.index].discount = 100;
											}
											this.$set(this.documentItem.retailDetailList[
													params.index],
												`priceAfterDiscount`, formatNum(this
													.documentItem.retailDetailList[
														params.index].price * (this
														.documentItem.retailDetailList[
															params.index].discount /
														100)));
											this.$set(this.documentItem.retailDetailList[
												params.index], `amount`, formatNum(
												this.documentItem.retailDetailList[
													params.index].quantity * this
												.documentItem.retailDetailList[
													params.index]
												.priceAfterDiscount));

										});
									}
								}
							})]
						}
					},
					{
						title: '折后单价',
						key: 'priceAfterDiscount',
						width: 140
					},
					{
						title: '总金额',
						key: 'amount',
						width: 200
					},
					{
						title: '备注',
						key: 'note',
						width: 350,
					}
				],
				userList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				accountPid: 'sfkzh'
			}
		},

		methods: {
			onInputVal(val) {
				this.$refs.selectCommodityModal.searchItems.name = val;
				this.$refs.selectCommodityModal.openSelectCommodityModal();
			},
			emptyForm() {
				this.documentItem.id = 0;
				//this.documentItem.code = '';
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
				this.documentItem.retailDetailList = [];
				this.documentItem.customerId = 0;
				this.documentItem.customerName = '';
				this.documentItem.customerDiscount = '100';
				//this.documentItem.payWay = this.payWayOptionList.length > 0 ? this.payWayOptionList[0].key : '';
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.userName = '';
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = '';
				this.documentItem.checkState = 1;
				this.documentItem.payAmount = 0;
				this.documentItem.extraCostInfos = [];
				this.documentItem.logisticsInfos = [{
					companyName: '',
					code: '',
					receiver: '',
					freight: 0,
					note: '',
					creator: parseInt(localStorage.getItem("userId")),
				}];
				this.extraAdvancePay = 0;
				this.dfAdvancePay = 0;
				this.documentItem.fileList = [];
				this.documentItem.amount = 0;
				this.documentItem.originalPrice = 0;
				this.getNextCode();
			},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}

				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				} else {
					//this.documentItem.businessDate = new Date(this.documentItem.businessDate);
				}

				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}

				if (this.documentItem.amount <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return false;
				}

				if (this.documentItem.payAmount > this.documentItem.amount) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "付款金额不得大于总金额"
					});
					return false;
				}
				
				let details = this.documentItem.retailDetailList;
				for(let i = 0;i<details.length;i++){
					if(details[i].commodity.enableBatch == true && (!details[i].batchCode || details[i].batchCode.length<=0)){
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: details[i].format +"规格未选择批次号"
						});
						return false
					}
				}
				
				return true;
			},
			getCommodityTypePrice(data) {
				const currentUnit = data.commodity.extraUnits.find(m => m.unit == data.unit);
				// 解析价格类型
				const priceTypeItems = data.format.split(',');
				let currentPriceType = null;

				if (priceTypeItems.length === 2) {
					currentPriceType = this.findPriceType(data.commodity, priceTypeItems);
				}
				if (currentUnit && currentPriceType) {
					let price = currentPriceType.retailPrice;
					return formatNum(price / currentUnit.conversionRate);
				}
				return 0;
			},
			// 提取价格类型查找逻辑
			findPriceType(commodity, priceTypeItems) {
				const [groupName, priceTypeName] = priceTypeItems;

				const targetGroup = commodity.commodityPriceTypeGroups.find(
					group => group.groupName === groupName
				);

				if (!targetGroup) return null;

				return targetGroup.commodityPriceTypes.find(
					priceType => priceType.priceType === priceTypeName
				) || null;
			},
			unitChange(index) {
				this.documentItem.retailDetailList[index].price = this.getCommodityTypePrice(this
					.documentItem.retailDetailList[index]);
				
				this.documentItem.retailDetailList[index]
					.priceAfterDiscount =
					formatNum(this.documentItem.retailDetailList[index]
						.price *
						(this
							.documentItem.retailDetailList[index].discount /
							100))
				
				this.documentItem.retailDetailList[index].amount = formatNum(
					this.documentItem.retailDetailList[index].quantity *
					this
					.documentItem.retailDetailList[index]
					.priceAfterDiscount);
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/RetailList/EditRetailList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录零售单操作
					var log = {
						FlowId: response.data,
						Title: '零售单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此零售单' : '创建了此零售单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
					self.emptyForm();
				}).catch(function(error) {})
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/RetailList/EditRetailList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录零售单操作
					var log = {
						FlowId: response.data,
						Title: '零售单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此零售单' : '创建了此零售单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					self.documentItem.id = response.data;
					self.checkRetailList([self.documentItem], '零售单过账后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/RetailList/GetNextCode', {
					params: {
						prefix: 'LSD'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			checkRetailList(objs, func) {
				var self = this;
				if (objs.length <= 0) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let stateObj = [];
				let retailIds = [];
				for (var i = 0; i < objs.length; i++) {
					if (objs[i].checkState != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "选中记录中包含不可过账的数据！"
						});
						return;
					}
					if (objs[i].payAmount < objs[i].amount) {
						stateObj.push({
							id: objs[i].id,
							state: 2
						});
					} else {
						stateObj.push({
							id: objs[i].id,
							state: 3
						});
					}
					retailIds.push(objs[i].id);
				}
				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/RetailList/CheckRetailList', stateObj).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							var log = [];
							for (var i = 0; i < retailIds.length; i++) {
								//记录零售单操作
								log.push({
									FlowId: retailIds[i],
									Title: '零售单日志',
									OperationContent: '过账了此零售单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '过账成功!'
							});
							self.emptyForm();
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			getUnitData(item,unit) {
				if (item.commodity.extraUnits) {
					let unitData = item.commodity.extraUnits.find(m => m.unit == unit);
					if (unitData) {
						return unitData;
					}
				}
				return null;
			},
			getLatestBatchCode(item1, item2) {
				if (item1.commodity.enableBatch != true) {
					return null;
				}
				if (!item1.commodity.commodityInventorys || item1.commodity.commodityInventorys.length <= 0) {
					return null;
				}
				let codes = [];
				let totalStock = 0;
				let unitData = this.getUnitData(item1,item2.unit);
				if(unitData){
					let latestCode = item1.commodity.commodityInventorys.filter(m => m.stock > 0 && m
						.commodityPriceType == item2.priceType).sort((a, b) => new Date(a.sellByDate[1]) - new Date(b.sellByDate[1]));
					for (let i = 0; i < latestCode.length; i++) {
						totalStock += formatNum(latestCode[i].stock * unitData.conversionRate);
						codes.push(latestCode[i].batchCode ? latestCode[i].batchCode : '无批次');
						if (totalStock > item2.quantity) {
							break;
						}
					}
				}
				return codes;
			},
			getSelectedCommodityTypeMaxStock(index) {
				let detail = this.documentItem.retailDetailList[index];
				if (!detail.commodity.commodityInventorys) return 0;
				let stock = 0;
				let commodityInventorys = detail.commodity.commodityInventorys;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == detail.format) {
						stock += commodityInventorys[i].stock;
					}
				}

				// 减去已选数量
				let details = this.documentItem.retailDetailList;
				for (let i = 0; i < details.length; i++) {
					if (i != index) {
						if (detail.format == details[i].format) {
							for (let j = 0; j < details[i].commodity.extraUnits.length; j++) {
								if (details[i].unit == details[i].commodity
									.extraUnits[j].unit) {
									stock -= details[i].quantity / details[i]
										.commodity.extraUnits[j].conversionRate;
								}
							}
						}
					}
				}

				let unitData = detail.commodity.extraUnits.find(m => m.unit == detail.unit);

				if (unitData) {
					stock = unitData.conversionRate * stock;
				}
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			formatBatchCodeSelectData(index,unit) {
				let data = this.documentItem.retailDetailList[index];
				let unitData = this.getUnitData(data,unit);
				if (data && unitData) {
					let list = []
					if (data.commodity.commodityInventorys) {
						let array = data.commodity.commodityInventorys.filter(m => m.stock > 0 && m
							.commodityPriceType == data.format);
						array = array.sort((a, b) => new Date(a.sellByDate[1]) - new Date(b.sellByDate[1]));
						for (let i = 0; i < array.length; i++) {
							list.push({
								value: array[i].batchCode,
								text: `${array[i].batchCode}(${formatNum(array[i].stock*unitData.conversionRate)}${unit})`
							})
						}
					}
					return list;
				}
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到审核流程？',
					onOk() {
						request.post('/api/RetailList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "零售单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录零售单操作
								log.push({
									FlowId: ids[i],
									Title: '零售单日志',
									OperationContent: '回滚了此零售单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getRetailList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			getCurrentIStock(index) {
				let commodityInventorys = this.documentItem.retailDetailList[index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem.retailDetailList[index].format) {
						stock += commodityInventorys[i].stock;
					}
				}
				let extraUnits = this.documentItem.retailDetailList[index].commodity.extraUnits;
				if (extraUnits) {
					extraUnits.forEach(item => {
						if (item.unit == this.documentItem.retailDetailList[index].unit) {
							stock = item.conversionRate * stock;
						}
					});
				}
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			countAmount() { //计算总金额
				this.documentItem.amount = 0;
				this.documentItem.originalPrice = 0;
				for (let i = 0; i < this.documentItem.retailDetailList.length; i++) {
					this.documentItem.originalPrice += this.getCommodityTypePrice(this.documentItem
							.retailDetailList[i])  *
						this.documentItem.retailDetailList[i].quantity;
					this.documentItem.amount += this.documentItem.retailDetailList[i].amount;
				}
				let totalFreight = 0;
				for (let i = 0; i < this.documentItem.logisticsInfos.length; i++) {
					totalFreight += formatNum(this.documentItem.logisticsInfos[i].freight);
				}
				this.documentItem.originalPrice = formatNum(this.documentItem.originalPrice + this
					.extraAdvancePay - this.dfAdvancePay + totalFreight)
				this.documentItem.amount = formatNum((this.documentItem.amount + this
					.extraAdvancePay - this.dfAdvancePay) + totalFreight);
				this.documentItem.payAmount = this.documentItem.amount
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['RetailList.Add', 'RetailList.Edit', 'RetailList.Delete',
						'RetailList.Audit', 'RetailList.BatchAudit', 'RetailList.Print',
						'RetailList.Rollback', 'RetailList.Export', 'RetailList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
						self.$Modal.warning({
							title:'系统到期提示',
							content: response.errorMsg,
							onOk:() => {
								localStorage.setItem("_tipTimeoutCount",1);
							}
						});
					}
					if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
						localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'RetailList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'RetailList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'RetailList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'RetailList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'RetailList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'RetailList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'RetailList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'RetailList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'RetailList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			packPrintData(data) {
				data.forEach((item,index)=>{
					switch(item.checkState){
						case 1:
							item.checkState = '已创建'
						break;
						case 2:
							item.checkState = '已过账'
						break;
						case 3:
							item.checkState = '已完结'
						break;
					}
					item.businessDate = item.businessDate.replace(' 00:00:00', '');
					item.extraCostInfos.forEach(item2=>{
						item2.createdate = item2.createdate.replace(' 00:00:00', '');
					});
				})
				let selectedReceiptData = {
					name: 'retailList',
					title:'零售单',
					attributes: ['baseFieldItem', 'retailDetailList', 'extraCostInfos',
						'logisticsInfos','footInfos'
					],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					retailDetailList: [{
							name: 'name',
							displayName: '名称'
						},
						{
							name: 'price',
							displayName: '单价'
						},
						{
							name: 'quantity',
							displayName: '数量'
						},
						{
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'discount',
							displayName: '折扣(%)'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						}
					],
					extraCostInfos: [{
							name: 'type',
							displayName: '费用类型'
						},
						{
							name: 'advancePayWay',
							displayName: '垫付方式'
						},
						{
							name: 'payAccount',
							displayName: '结算账户'
						},
						{
							name: 'amount',
							displayName: '金额'
						},
						{
							name: 'createdate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					logisticsInfos: [{
							name: 'companyName',
							displayName: '物流公司'
						},
						{
							name: 'code',
							displayName: '物流单号'
						},
						{
							name: 'receiver',
							displayName: '收货人'
						},
						{
							name: 'freight',
							displayName: '运费'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					],
					footInfos: [{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'payAmount',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				}
				localStorage.setItem('_printData', JSON.stringify(selectedReceiptData));
				this.$router.push({
					path: 'printerpage'
				});
			},
			printList() {
				this.packPrintData([this.documentItem]);
			},
			getRetailList(retailId) {
				let self = this;
				request.get('/api/RetailList/GetRetailList', {
					params: {
						id: retailId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initRetailList(response.data);
				}).catch(function(error) {})
			},
			initRetailList(data) {
				this.documentItem = data;
			}
		},
		watch: {
			'documentItem.retailDetailList': {
				deep: true,
				handler(arr) {
					this.countAmount();
				}
			},
			'documentItem.logisticsInfos': {
				deep: true,
				handler(arr) {
					this.countAmount();
				}
			},
			'documentItem.extraCostInfos': {
				deep: true,
				handler(arr) {
					this.extraAdvancePay = 0;
					this.extraSelfPay = 0;
					this.dfAdvancePay = 0;
					for (let i = 0; i < arr.length; i++) {
						if (arr[i].advancePayWay == "我方垫付") {
							this.extraAdvancePay += arr[i].amount;
						} else if (arr[i].advancePayWay == "对方垫付") {
							this.dfAdvancePay += arr[i].amount;
						} else if (arr[i].advancePayWay == "我方自付") {
							this.extraSelfPay += arr[i].amount;
						}
					}
					this.extraAdvancePay = formatNum(this.extraAdvancePay);
					this.extraSelfPay = formatNum(this.extraSelfPay);
					this.dfAdvancePay = formatNum(this.dfAdvancePay);
					this.countAmount();
				}
			},
			'$route.query.retailListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getRetailList(param);
					} else {
						this.emptyForm();
					}
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6pxrgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}

	#extraCostInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.logisticsInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}
</style>